<div class="tooltiptext">
  <div class="">
    <div class="tooltip-content desktop">
      <ng-container *ngIf="tooltipTitle">
        <div class="tooltip-title fw-700 margin-bottom mb8">
          {{tooltipTitle}}
        </div>
      </ng-container>
      <div class="tooltip-description">
        {{description}} <span *ngIf="linkTitle && link" [ngClass]="{'display-block-coverage':linkBlock}"><a [href]="link" target="_blank">{{linkTitle}}</a></span>
      </div>
    </div>
    <div class="tooltip-content mobile">
      <ng-container *ngIf="tooltipTitle">
        <div class="tooltip-title fw-700 margin-bottom mb8">
          {{tooltipTitle}}
        </div>
      </ng-container>
      <div class="tooltip-description">
        {{description}} <span *ngIf="linkTitle && link" [ngClass]="{'display-block-coverage':linkBlock}"><a [href]="link" target="_blank">{{linkTitle}}</a></span>
      </div>
    </div>
  </div>
</div>